import { FIRST_LOAD_STATE_WAIT_MS } from 'projects/service/src/app/shared/utils/grid-persistence';
import { GridConfig } from '@inavista/components/grid';

// The shared History tab (parts order, cart checkout, shipment, return, core return, calibration, cycle count,
// inventory adjustment / transfer, freight charges, ISC rules, ISC claims, ms-dynamic and shipment adjustment popups)
// on @inavista/components. Same columns, labels, widths, date format and toolbar as the Syncfusion grid it replaces.
// Rows: the popup's own `history` input (LocalRowsGridApi, no endpoint). No paging (Martin): the grid scrolls.

export const HISTORY_TAB_URL = 'page://history-tab-shared';
export const HISTORY_TAB_PERSISTENCE_KEY = 'rims.service.history-tab-shared';

export const HISTORY_TAB_COLUMNS: [string, string][] = [
  ['createdByName', 'nvarchar'],
  ['text', 'nvarchar'],
  ['createdDate', 'datetime'],
];

const LEFT = { horizontal: 'left' as const, header: { horizontal: 'left' as const } };

export function buildHistoryTabGridConfig(canExport: boolean): GridConfig {
  return {
    apiBaseUrl: HISTORY_TAB_URL,
    clientSide: true,
    // A synthetic key (the history rows have none); not a column.
    keyColumn: 'rowId',
    // 30, as the other Service Order popup grids.
    rowHeight: 30,
    defaultColumnOrder: ['createdByName', 'text', 'createdDate'],
    columnLabels: { createdByName: 'Updated By', text: 'Description', createdDate: 'Created Date' },
    // Updated By 70 and Created Date 120 as before (a longer value ends in an ellipsis, as before); Description had no
    // width and took the rest.
    columnWidths: { createdByName: 70, text: 400, createdDate: 120 },
    stretchColumns: true,
    columnSizing: { createdByName: { noStretch: true }, createdDate: { noStretch: true } },
    columnAlign: { createdByName: LEFT, text: LEFT, createdDate: LEFT },
    columnTypes: { createdDate: 'datetime' },
    // The old format, seconds and AM/PM included.
    columnDateFormats: { createdDate: 'd MMM, y hh:mm:ss a' },
    // Updated By had the checkbox (Excel) filter; Description and Created Date the menu filter.
    excelFilterColumns: ['createdByName'],
    // Syncfusion's default: Ctrl+click adds a sort level.
    multiSort: true,
    // The old toolbar: Show/Hide Columns, Search, Excel export (role AllGrid_Toolbar_Excel_Export), Clear filters.
    // Reset layout is kept: it undoes the saved layout.
    enableColumnsPicker: true,
    enableExport: canExport,
    enableSavedViews: false,
    enableScrollButtons: false,
    enableFitColumns: false,
    enableResetLayout: true,
    enableRefresh: false,
    enableFooter: false,
    emptyStateMessage: 'No records to display',
    // Right-click a cell filters by its value (Martin, 2026-10-29: every grid that filters).
    enableContextMenuFilter: true,
    persistenceKey: HISTORY_TAB_PERSISTENCE_KEY,
    firstLoadStateWaitMs: FIRST_LOAD_STATE_WAIT_MS,
  };
}
